import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-1', 'Number1', [["path",{"d":"M13 20v-16l-5 5"}]]);